/** @type {Set<import('tippy.js').Instance>} */
export const headerTippyInstances = new Set();

/**
 * @param {import('tippy.js').Instance} instance
 * @param {Event} event
 */
export const closeAllExceptThis = (instance, event) => {
	for (const currentInstance of headerTippyInstances) {
		if (instance !== currentInstance) {
			currentInstance.unmount();
		}
	}
};
